export const isVisible = (element) => {
    if (!element) return true;

    const style = window.getComputedStyle(element);

    if (style.display === 'none' || style.visibility === 'hidden') {
        return false;
    }
    return isVisible(element.parentElement);
};
